import _Tooltip from "@material-ui/core/esm/Tooltip";
import _Badge from "@material-ui/core/esm/Badge";
import _IconButton from "@material-ui/core/esm/IconButton";
import React from 'react';
import cn from 'classnames';
import deleteIconRedCross from 'assets/svg/delete-icon-red-cross.svg';
import { withStyles } from '@material-ui/core/styles';
import Image from 'swag-client-common/components/ui/image';
import { variables } from 'swag-client-common/styles/variables-js';
import classes from './item.scss';
const IconButtonStyled = withStyles({
  root: {
    backgroundColor: variables.colorGreyBoxDefaultBtn,
    width: '24px',
    height: '24px',
    padding: '2px',
    top: '-11px',
    left: '86px',
    '&:hover': {
      backgroundColor: variables.colorGrey6
    }
  }
})(_IconButton);
const iconClasses = {
  root: classes.icon
};
const budgeClasses = {
  root: classes.quantity,
  badge: classes.budge
};
export const Item = ({
  item,
  giveawayColor,
  onClick
}) => {
  if (!item) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn(classes.wrapper, classes.block)
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        color: giveawayColor
      }
    }, "Select your products below"));
  }
  const {
    image,
    name,
    quantity
  } = item;
  const handleRemoveClick = () => {
    onClick(item);
  };
  return /*#__PURE__*/React.createElement(_Tooltip, {
    arrow: true,
    title: name,
    placement: "top"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.block,
    "data-productId": item._id
  }, /*#__PURE__*/React.createElement(Image, {
    src: image,
    alt: name,
    wrapperClassName: classes.wrapper
  }), quantity > 1 && /*#__PURE__*/React.createElement(_Badge, {
    classes: budgeClasses,
    badgeContent: quantity,
    color: "secondary"
  }), /*#__PURE__*/React.createElement(IconButtonStyled, {
    classes: iconClasses,
    onClick: handleRemoveClick
  }, /*#__PURE__*/React.createElement("img", {
    src: deleteIconRedCross
  }))));
};